import React from 'react';
import styled from 'styled-components';
import { Spinner } from 'src/components/animations/Spinner';

const HotelMapLoader = () => (
  <MapLoaderBg>
    <Spinner />
  </MapLoaderBg>
);

const MapLoaderBg = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background-color: rgb(184, 184, 184);
`;

export default HotelMapLoader;
